import apiClient from './apiClient';
import { GET_EXCHANGE_RATE_LIST_URL } from './apiUrl';

const getExchangeRateListApi = () => {
  return apiClient.get(GET_EXCHANGE_RATE_LIST_URL);
};

export default getExchangeRateListApi;
